import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Note: StrictMode is disabled to prevent double WebSocket connections in development
root.render(<App />);

